import React from "react";
import { format } from "date-fns";
import { ICellRendererParams } from "@ag-grid-community/core";

import { GridInvoice } from "../../../types";

import styles from "./PeriodDateRenderer.module.scss";

interface Props extends ICellRendererParams {
  data: GridInvoice;
}

const PeriodDateRenderer = ({ data }: Props) => {
  const { periodStartDate, periodEndDate } = data;

  const startDate = format(new Date(periodStartDate), "MMM d, yyyy");
  const endDate = format(new Date(periodEndDate), "MMM d, yyyy");

  return (
    <div className={styles.periodDate}>
      <span>{startDate}</span>
      <span>{endDate}</span>
    </div>
  );
};

export default PeriodDateRenderer;
